function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 8c0-2.207 1.99-4.438 5.843-6.872a3 3 0 0 1 4.043.792l3.682 5.154a1.5 1.5 0 0 1-.16 1.933l-1.2 1.2a3.843 3.843 0 0 0-.289 5.113 23.954 23.954 0 0 0 1.788 1.973 23.97 23.97 0 0 0 1.973 1.788 3.843 3.843 0 0 0 5.113-.288l1.2-1.2a1.5 1.5 0 0 1 1.933-.16l5.154 3.68a3 3 0 0 1 .792 4.044C28.438 29.01 26.207 31 24 31c-3.383 0-8.607-3.192-13.707-8.293C4.972 17.386 1 11.275 1 8zm11.694-.108l-3.435-4.81A1 1 0 0 0 7.91 2.82C4.595 4.914 3 6.702 3 8c0 2.57 3.743 8.328 8.707 13.293C16.464 26.05 21.292 29 24 29c1.298 0 3.086-1.595 5.181-4.911a1 1 0 0 0-.264-1.348l-4.809-3.435-.9.901a5.843 5.843 0 0 1-7.774.438 25.911 25.911 0 0 1-2.141-1.938 25.927 25.927 0 0 1-1.938-2.14 5.843 5.843 0 0 1 .438-7.774l.9-.901z"
});

var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "1c1c112f18ed73ed511171e80ea6ad06.svg";
export { SvgCall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/call.svg
// module id = null
// module chunks = 